import { render, staticRenderFns } from "./AuditStatusFeedComment.vue?vue&type=template&id=39bd51d7&"
import script from "./AuditStatusFeedComment.vue?vue&type=script&lang=js&"
export * from "./AuditStatusFeedComment.vue?vue&type=script&lang=js&"
import style0 from "./AuditStatusFeedComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports